/* eslint-disable no-restricted-globals */
import * as React from "react";
import "./App.css";
import {
  Route,
  RouterProvider,
  Routes,
  createBrowserRouter,
  useLocation,
  
} from "react-router-dom";
import HomePage from "./pages/HomePage";
import { Navbar } from "./components";
import Footer from "./components/Footer";
import CategoriesPage from "./pages/CategoriesPage";
import ListingDetailPage from "./pages/ListingDetailPage";
import Messages from "./pages/MessagesPage";
import Chat from "./pages/ChatPage";
import DashboardPage from "./pages/DashboardPage";
import SubmitClassified from "./pages/SubmitClassified";
import EditPage from "./pages/EditPage/";
import JobDetailPage from "./pages/JobDetailPage";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import "./components/SubmitClassifiedForms/SubmitInformationForm/index.css";
import ChatPage from "./pages/ChatPage";

// Make sure to call `loadStripe` outside of a component’s render to avoid
// recreating the `Stripe` object on every render.
const stripePromise = loadStripe(
  "pk_live_51Q1zHPRpk8CbY2SD3XfeJLzG15VJjicTiIFN6AxNsykwdy5oqaHb8iC1tiDzawCtXkF8Ice0i73Y7b9fvYmGW0AR003qgLamgD"
);

function App() {
  const routes = [
    {
      path: "/",
      element: <HomePage />,
    },
    {
      path: "/categories/:categoryId",
      element: <CategoriesPage />,
    },
    {
      path: "/listing/:id",
      element: <ListingDetailPage />,
    },
    {
      path: "/job/:id",
      element: <JobDetailPage />,
    },
    {
      path: "/messages",
      element: <Messages />,
    },
    {
      path: "/messages/:from",
      element: <ChatPage />,
    },
    {
      path: "/dashboard",
      element: <DashboardPage />,
    },
    {
      path: "/submit",
      element: <SubmitClassified />,
    },
    {
      path: "/edit/:id?",
      element: <EditPage />,
    },
  ];


  const location = useLocation();

  React.useEffect(() => {
    // but only in back navigation
    // Attempt to restore scroll position for back navigation
    if (location.action === 'POP') {
      const scrollPosition = sessionStorage.getItem(location.pathname);
      if (scrollPosition) {
        window.scrollTo(0, scrollPosition - 100);
      } else {
        window.scrollTo(0, 0);
      }
    }
    else {
      window.scrollTo(0, 0);
    }

    // Save the scroll position before the component unmounts or on path change
    return () => {
      sessionStorage.setItem(location.pathname, window.scrollY);
    };
  }, [location.pathname]);


  // React.useEffect(() => {
  //   console.log(location);
  //   if (!location.pathname.includes('categories')) {
  //     setTimeout(() => {
  //       window.scrollTo({
  //         top: 0,
  //         behavior: "smooth",
  //       });
  //     }, 0);
  //   }
  // }, [location]);

  return (
    <Elements stripe={stripePromise}>
      <div className="App">
        <ToastContainer />
        {location.pathname !== "/" && <Navbar />}
        <div>
          <Routes>
            {routes.map((route, index) => (
              <Route path={route.path} element={route.element} />
            ))}
          </Routes>
        </div>
        <Footer />
      </div>
    </Elements>
  );
}

export default App;

export { stripePromise };
